<ng-container *ngIf="error$ | async as generalError; else notFoundError">
  <ish-server-error [error]="generalError" [type]="type$ | async"></ish-server-error>
</ng-container>

<ng-template #notFoundError><ish-error></ish-error></ng-template>
